<div style="margin-top: 81px;">
  <p-table 
    #dt1 
    [columns]="cols" 
    [value]="companyList" 
    [tableStyle]="{ 'width': '75%', 'margin-left': 'auto', 'margin-right': 'auto'}" 
    styleClass="p-datatable-striped p-datatable-gridlines"
    dataKey="id"
    selectionMode="single"
    [(selection)]="selected"
    responsiveLayout="stack" 
    [breakpoint]="'500px'"
    [loading]="loading"

    class="bg-white"
  >
    <ng-template pTemplate="caption">
      <div class="title">{{ "companies" | translate }}</div>
      <div class="relative mb-3">
        <input
          #companyName
          [(ngModel)]="searchValue"
          pInputText
          style="float: left; margin-left: 11.8%; width: 25%; background-color: var(--list-bg-color); color: var(--text-color); -webkit-transition: 0s; transition: 0s;"
          type="text"
          placeholder="Name"
          class="pl-3 pr-3 border border-gray-300 focus:border-blue-500 h-10 outline-none font-sans text-lg font-light"
        >
        <button
          style="float: left; margin-left: 1%; width: 100px"
          class="items-center justify-center text-center button h-10 text-lg cursor-pointer rounded" 
          (click)="searchCompany(searchValue)"
        >
          {{"search" | translate}}
        </button>
        <button
          style="margin-top: 8px; margin-left: 5px; color: var(--text-color);"
          (click)="clearSearch()"
        >
          {{"clear" | translate}}
        </button>
        <button
          style="float: right; margin-right: 11.8%; width: 145px"
          class=" items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
          (click)="jumpCreateCompany()"
        >
          {{"addCompany" | translate}}
        </button>
      </div>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData" style="border: 1px solid var(--list-border-color); background-color: var(--list-bg-color); cursor: auto">
        <td class="truncate font-sans text-sm">
          <div class="name-area">
            <div class="company-name" style="overflow: hidden; text-overflow: ellipsis; max-width: 800px;"> {{rowData.name}} </div>
            <div class="header" style="overflow: hidden; text-overflow: ellipsis; max-width: 800px"> {{rowData.otherName}} </div>
          </div>
          <div class="company-id-area"> 
            ID: {{rowData.id}} 
            <button
              style="width: 45px; display: inline-block; border: 1px solid; margin-left: 3px;"
              class="items-center justify-center text-center font-inter cursor-pointer rounded"
              (click)="copyCompanyId(rowData.id)"
            >
              {{"copy" | translate}}
            </button>
          </div>
          <hr style="width: 120%; margin-left: -30px; border-color: var(--list-border-color);">
          <div style="float: top;">
            <div class="details-area">
              <div class="details">
                {{rowData.typeOwner === 1 ? 'Owner' : 'Other' }}
              </div>
              <div class="header"> {{"companyType" | translate}} </div>
            </div>
            <div class="details-area">
              <div class="details">
                {{rowData.address}}
              </div>
              <div class="header"> {{"address" | translate}} </div>
            </div>
            <div class="details-area">
              <div class="details">
                {{rowData.businessContents}}
              </div>
              <div class="header"> {{"businessArea" | translate}} </div>
            </div>
          </div>
          <div>
            <div class="btn">
              <button *ngIf="!auth.isYakuin" mat-raised-button style="background-color: #28b6c7; width: 105px" (click)="onButtonClick(rowData)">
                {{"viewEdit" | translate}}
              </button>
            </div>
            <div class="update-time">Updated {{rowData.updatedAt.replace('T', ' ').replace('Z', '').slice(0, 16)}} UTC</div>
          </div>
        </td>
      </tr>
      <br>
    </ng-template>
  </p-table>
  <div *ngIf="isSearched && !isSearching && companyList.length==0" class="noCompanyMsg">{{"noCompanies" | translate}}</div>
  <br />
  <mat-paginator
    *ngIf="!isSearched && companyList.length != 0"
    [length]="length"
    [pageIndex]="pageIndex"
    [showFirstLastButtons]=true
    [pageSize]=50
    (page)="pageEvent = onPageChange($event)"
    [style]="{'font-size': '15px', 'margin-right': '50px'}"
    hidePageSize="true"
  >
  </mat-paginator>
</div>